/*
 *
 * Attendance actions
 *
 */

import {
  FLUSH_STATE_ATTENDANCE,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR,
/*   DELETE_ATTENDANCE,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_ERROR, */
} from './constants';

/**
 * Clearing the state for Attendance
 */
export function flushStateAttendance() {
  return {
    type: FLUSH_STATE_ATTENDANCE,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the courses, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COURSES
 */
export function loadMobileCourses(options) {
  return {
    type: LOAD_COURSES,
    options
  };
}

/**
 * Dispatched when the loadCourses are loaded by the request saga
 *
 * @param  {array} variables true for courses
 *
 * @return {object}      An action object with a type of LOAD_COURSES_SUCCESS passing the variables
 */
export function loadCoursesSuccess(itemsList) {
  return {
    type: LOAD_COURSES_SUCCESS,
    itemsList
  };
}

/**
 * Dispatched when loading the loadCourses fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COURSES_ERROR passing the error
 */
export function loadCoursesError(error) {
  return {
    type: LOAD_COURSES_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the Attendance, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_ATTENDANCE

export function deleteAttendance(id) {
  return {
    type: DELETE_ATTENDANCE,
    id,
  };
}
 */

/**
 * Dispatched when the deleteAttendance are deleted by the request saga
 *
 * @param  {object} variables true for Attendance
 *
 * @return {object} An action object with a type of DELETE_ATTENDANCE_SUCCESS passing the variables

export function deleteAttendanceSuccess() {
  return {
    type: DELETE_ATTENDANCE_SUCCESS,
  };
}
*/

/**
 * Dispatched when loading the deleteAttendance fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_ATTENDANCE_ERROR passing the error

export function deleteAttendanceError(error) {
  return {
    type: DELETE_ATTENDANCE_ERROR,
    error,
  };
}
 */